import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=3c1a3f52&scoped=true&"
import script from "./UploadDocument.vue?vue&type=script&lang=js&"
export * from "./UploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a3f52",
  null
  
)

export default component.exports